import React from "react";
import styled from "styled-components";

const Container = styled.div`
  color: black;
  line-height: 1.6;
  font-family: Arial, sans-serif;
  font-size: 14px;

  @media (max-width: 768px) {
    padding-top: 60px; /* dodatni prostor za fiksiran img */
  }
`;

const Year = styled.div`
  font-weight: bold;
  margin-top: 1em;
  margin-bottom: 0.2em; /* manja margina ispod godine */
`;

const Paragraph = styled.p`
  margin: 0 0 1em 0; /* samo donja margina */
`;

const Italic = styled.i`
  font-style: italic;
`;

const Bold = styled.b`
  font-weight: bold;
`;

const NadezdaPetrovic = () => {
  return (
    <Container>
      <Paragraph>
        <Bold>Nadežda Petrović</Bold> je rođena 11. oktоbra 1873. u Čačku. Otac
        Dimitrije Mita Petrović je bio nastavnik crtanja u Realnoj gimnaziji u
        Čačku, a majka Mileva Zorić je bila učiteljica. Nadežda je najstarija od
        devetoro dece koje su imali.
      </Paragraph>

      <Year>1879.</Year>
      <Paragraph>
        Sa porodicom prelazi u Karanovac (Kraljevo) zbog službe roditelja.
      </Paragraph>

      <Year>1884.</Year>
      <Paragraph>
        Porodica Petrović odlazi za Beograd. Prve osnove iz slikarstva dobija od
        svog ujaka Svetozara Zorića kasnije nastavnika istorije umetnosti, stila
        i ornamentike u školi Kirila Kutlika. Iste godine upoznaje cenjenog
        slikara Đorđa Krstića, očevog prijatelja.
      </Paragraph>

      <Year>1891.</Year>
      <Paragraph>
        Završava Višu žensku školu u Beogradu. Slikarstvo uči kod Đorđa Krstića
        sve do odlaska u Minhen 1898. Jedine sačuvane slike iz vremena
        Krstićevih pouka su <Italic>Mrtva priroda sa crvenim sudom</Italic>{" "}
        (1898.) i <Italic>Betoven</Italic> (1898.)
      </Paragraph>

      <Year>1892.</Year>
      <Paragraph>
        Piše molbu Ministarstvu prosvete da joj se omogući da predaje kao
        nastavnica crtanja. Polaže ispit za nastavnicu crtanja pred komisijom
        koju su sačinjavali: Mihailo Valtrović, Đorđe Krstić, Dimitrije
        Andrejević.
      </Paragraph>

      <Year>1893.</Year>
      <Paragraph>
        Postaje učiteljica crtanja u Višoj ženskoj školi u Beogradu.
      </Paragraph>

      <Year>1896. i 1897.</Year>
      <Paragraph>
        Pohađa školu (žensko odeljenje) Kirila Kutilika u Beogradu. Škola je
        davala osnovna predznanja za dalje likovno obrazovanje. Kroz školu je
        prošla generacija budućih slikara: Bora Stevanović, Milan Milovanović,
        Kosta Milićević, Dragomir Glišić...
      </Paragraph>

      <Bold>MINHEN</Bold>

      <Year>1898.</Year>
      <Paragraph>
        Piše molbu Ministru prosvete i crkvenih poslova Andri Đorđeviću, da joj
        odobri odsustvo od dužnosti učiteljice radi usavršavanja na Minhenskoj
        akademiji. Molba je pozitivno rešena. Ona odlazi u Minhen na školovanje
        kod Antona Ažbea gde će upoznati slikare: Borivoja Stevanovića, Milana
        Milovanovića, Ivana Grohara i druge. I pored toga što žene još uvek nisu
        imale pravo da pohađaju Akademiju umetnosti u Minhenu, Akademija će ipak
        overiti i priznati Ažbeove diplome. Kod Ažbea ostaje do 1901. Za vreme
        njenog školovanja u Minhenu, 3. marta 1898. rodio se njen najmlađi brat
        Rastko Petrović.
      </Paragraph>

      <Year>1899.</Year>
      <Paragraph>
        Na putu od Beograda ka Minhenu obilazi Zagreb, Fijumi (Rijeku), Trst i
        III Bijenale u Veneciji. U Minhenu proučava dela iz Pinakoteke, secesiju
        i upoznaje se sa ruskim krugom umetnika Jevlenskim, Kandinskim,
        Minterom, Verefkinovom. Upoznaje i Riharda Jakopiča i Matiju Jamu. Iste
        godine upisuje se u Državnu školu za primenjenu umetnost i zato dobija
        veću stipendiju od Ministarstva privrede. Sve vreme bavi se
        fotografijom.
      </Paragraph>

      <Year>1900.</Year>
      <Paragraph>
        Posećuje izložbu Minhenske secesije. Prvi put vidi slike francuskih
        slikara Koroa, Monea, Renoara i Sisleja. U Sali Velike škole u Beogradu
        otvara svoju prvu samostalnu izložbu. Pera Odavić piše oštru kritiku o
        izložbi u časopisu Nova iskra.
      </Paragraph>

      <Year>1901.</Year>
      <Paragraph>
        Putuje po Nemačkoj. U Berlinu na izložbi Secesije upoznaje se sa delima
        Monea, Pisaroa, Renoara, Tuluza Lotreka, Beklina, Korinta i Ekstera.
        Posle školovanja kod Ažbea prelazi kod Juliusa Ekstera, profesora
        Minhenske akademije i potpisnika memoranduma Minhenske secesije. Počinje
        da radi na otvorenom, u pleneru nastaju motivi prirode i pejzaža. U tom
        periodu nastaje slika Put kroz jelovu šumu.
      </Paragraph>

      <Year>1902.</Year>
      <Paragraph>
        Nastavlja školovanje kod Ekstera. U Beču posećuje prolećnu izložbu u
        palati Secesije gde vidi Betovenov friz Gustava Klimta koji u akademskim
        krugovima toga vremena izaziva dosta polemike. Aktivno slika u okolini
        Minhena. Tad nastaju značajna dela kolorističke faze Nadeždinog
        stvaralaštva među kojima i Stablo u šumi.
      </Paragraph>

      <Bold>SRBIJA</Bold>

      <Year>1903.</Year>
      <Paragraph>
        U Beču posećuje izložbu impresionistа i postimpresionistа. Nastaje delo
        Iz Iberzea. Ovo je godina njenog povratka u Srbiju. Počinje sa
        političkim, društvenim i humanističkim angažamanom. Saradnica je većine
        listova u Srbiji. Piše o slikarstvu i likovnoj umetnosti, školstvu i
        potrebama modernizacije nastave, o obrazovanju ženske omladine i
        emancipaciji žena, o pozorištu, muzici i dr. Podržava ideju oslobođanja
        južnoslovenskih naroda. Organizuje veliki ženski skup gde se zalaže za
        buđenje patriotske svesti žena, za političku i socijalnu pravdu, za
        prikupljanje pomoći Srbima izvan Srbije. Osniva Kolo srpskih sestara i
        postaje prvi sekretar ove organizacije. Putuje u Makedoniju i nosi pomoć
        postradalom življu. Piše svoju jedinu pozorišnu dramu izrazito
        političkog karaktera O živim slikama iz Makedonije i Srbije.
      </Paragraph>

      <Year>1904.</Year>
      <Paragraph>
        Učestvuje u osnivanju i organizovanju Prve jugoslovenske umetničke
        izložbe. Povod za izložbu bila je stogodišnjica Prvog srpskog ustanka i
        krunisanje Petra I Karađorđevića. Učesnici-izlagači na izložbi su bili
        srpski, hrvarski, slovenački i bugarski umetnici čime je afirmisana
        južnoslovenska ideja. Izložbu je otvorio kralj Petar I, koji je otkupio
        41 delo i odlikovao najistaknutije umetnike. Od nekoliko slika koje je
        Nadežda ponudila za izložbu, žiri je prihvatio samo sliku Žetva. Kritike
        o izložbi pored Nadežde Petrović pišu i Bogdan Popović, Miloje Vasić,
        Vladimir Petković, Vladislav Petković Dis. Nadežda učestvuje u dogovoru
        oko osnivanja Prve jugoslovenske umetničke kolonije. Ideja kolonije je
        da okupi grupu maldih jugoslovenskih umetnika čija bi likovna delatnost
        činila osnovu nove jugoslovenske savremene umetnosti. Inicira i ideju za
        osnivanje Jugoslovenske umetničke galerije. Učestvuje u osnivanju Saveza
        jugoslovenskih umetnika „Lada”, čija je svrha zajednička borba svih
        jugoslovenskih umetnika na polju jugoslovenske umetnosti. To je period
        nastanka njenih slika, Resnik (Višnjica) i Staro groblje. Odlikovana je
        Ordenom Svetog Save IV stepena.
      </Paragraph>

      <Year>1905.</Year>
      <Paragraph>
        Na međunarodnu izložbu u Liježu, na kojoj nastupa “Lada”, Nadežda
        Petrović nije pozvana. Boravi u Minhenu, Beču i Zagrebu gde prisustvuje
        jubileju "Hrvatskog društva umjetnosti" i izložbi za koju piše kritiku.
        U okolini Sićeva počinje sa radom Prva jugoslovenska umetnička kolonija
        koju čine Nadežda Petrović, Ferdo Vesel, Rihard Jakopič, Ivan Grohar i
        Paško Vučetić, kasnije se pridružuju Ivan Meštrović i Emanuel Vidović.
        Umetnici izlaze u prirodu i slikaju predele Sićeva. Tada nastaju
        Nadeždine slike: Ciganka sa crvenim šalom, Pogreb u Sićevu.
      </Paragraph>

      <Year>1906.</Year>
      <Paragraph>
        Otvorena je Prva izložba “Lade” u prostorijama Srpskog poljoprivrednog
        društva. Izložbu je otvorio kralj Petar I. Nadežda izlaže pejzaže i
        portrete koji su rezultat njenog rada u Koloniji. Kritika joj nije
        blagonaklona izuzev kritike Branka Popovića. Na Drugoj jugoslovenskoj
        izložbi u Sofiji “Lada” po drugi put ne prihvata Nadeždino učešće što će
        biti razlog za njen odlazak iz “Lade”. Radi na pripremi izložbe
        Jugoslovenske umetničke kolonije koja je imala za cilj da afirmiše
        napredne umetničke ideje i predstavi grupu modernih likovnih stvaralaca
        na početku 20 veka.
      </Paragraph>

      <Year>1907.</Year>
      <Paragraph>
        Otvorena izložba Jugoslovenske umetničke kolonije u prostorijama
        Narodnog muzeja. Među učesnicima pored Nadežde Petrović su i Paško
        Vučetić, Ivan Grohar, Matija Jama, Rihard Jakopič, Ivan Meštorvić,
        Emanuel Vidović, Tomislav Krizman, Mirko Rački, Ante Katunarić, Nikola
        Mihailov i Aleksandar Božinov. Nadežda izlaže slike Ribari na Dunavu,
        Jesen, Na kladencu i dr. Kritika je primećuje ali i dalje nema
        razumevanja za njen rad. Česti gosti porodice Petrović bili su svi
        članovi kolonije. Ivan Grohar boravi par meseci u kući Petrovića, tada
        nastaje njegov Portret Nadežde Petrović u pastelu. Podstiče je da uradi
        Autoportret. Nadežda posećuje, Beč, Minhen, Veneciju i Rim. Sa Brankom
        Popovićem obilazi VII bijenale u Veneciji gde upoznaje dela Sinjaka,
        Vijara, Ensora... Tada nastaju slike: Selo (Cigansko predgrađe), Portret
        Branka Popovića, Portret Jovana Skerlića, Koloseum i Pompeji. Ona je
        osnivač Srpskog umetničkog udruženja. To je period nastanka ključnih
        dela srpskog impresionizma među kojima su i Nadeždine slike: Dereglije
        na Savi, Karaula na Savi, Devojka sa suncobranom.
      </Paragraph>
      <Year>1908.</Year>
      <Paragraph>
        Izlaže na izložbi Srpskog umetničkog udruženja u Beogradu. Odlazi na
        Sveslovenski kongres u Prag gde se zalaže za priređivanje sveslovenske
        umetničke izložbe. Putuje u Ljubljanu na Osmi sveslovenski kongres
        novinara kada kao gost boravi kod Riharda Jakopiča. Posećuje Prvu
        dalmatinsku izložbu u Splitu na kojoj izlažu njeni prijatelji Meštrović,
        Vučetić i Vidović. Piše kritiku izložbe. Pored ove daje i kritiku
        izložbe Paška Vučetića. Povodom aneksije Bosne i Hercegovine (6.
        oktobra) Nadežda organizuje protestni skup žena i pokret za bojkot
        austrougarske i nemačke robe. Na balkonu Narodnog pozorišta drži
        politički govor. Postaje član patriotskog društva Narodna odbrana.
      </Paragraph>
      <Year>1909.</Year>
      <Paragraph>
        Putuje u Minhen i Berlin sa Brankom Popovićem. Piše kritiku za Drugu
        izložbu “Lade”. Upućuje molbu Ministarstvu prosvete i Državnom savetu da
        joj se poveća plata i omogući ostvarenje prava na penziju na osnovu
        dugogodišnjeg rada na Višoj ženskoj školi. U njenim slikama uočava se
        prodor kolorizma. Nastaje Dama sa crnim šeširom na glavi.
      </Paragraph>

      <Bold>PARIZ</Bold>

      <Year>1910.</Year>
      <Paragraph>
        Otvara drugu samostalnu izložbu u Jakopičevom umetničkom paviljonu u
        Ljubljani, u okviru programa Prolećne izložbe. Izlaže 37 slika iz
        perioda 1907–1910. Slovenačka kritika je ne podržava. Ivan Cankar takođe
        piše oštru kritiku o izložbi. Nadežda posećuje Meštrovićevu izložbu u
        Zagrebu i o njemu piše kritiku punu hvale. Posle mnogo truda dobija
        stipendiju i odlazi za Pariz. Živi u ateljeu Ivana Meštrovića u Parizu.
        Pohađa časove “Academie russe (Vassileff)” i izlaže sa Ruskim umetničkim
        i književnim udruženjem. U kontaktu je sa našim umetnicima u Parizu,
        Brankom Popovićem, Miroslavom Kraljevićem, Vladimirom Becićem i Ljubom
        Babićem. Izlaže na Jesenjem salonu dve slike: Bdenje pored mrtvaca i
        Predgrađe Pirota. Učesnici te izložbe su i Bonar, Matis, Kandinski,
        Laprad, Valmenk, Leže, Vijar i dr. Beogradska štampa je zabeležila ovaj
        Nadeždin važan nastup. Učestvuje i na Prvoj internacionalnoj izložbi
        Ruskog umetničkog i književnog udruženja. Pod uticajem francuskih
        fovista, koje ima prilike da upozna, nastaju slike jakog kolorita:
        Bulonjska šuma, Kej na Seni, Most na Seni, Plaža u Bretanji. Na izložbi
        dalmatinskog društva "Medulić" u Zagrebu koju organizuje Ivan Meštrović,
        izlaže tri pejzaža među kojima i sliku Bogorodičina crkva u Parizu.
        Članstvo društva "Medulić" prošireno je pojedinim srpskim, hrvatskim i
        slovenačkim umetnicima.{" "}
      </Paragraph>

      <Year>1911.</Year>
      <Paragraph>
        Održana je međunarodna izložba u Rimu. U paviljonu Srbije izlažu i
        hrvatski umetnici što će izaztvati sukobe na kulturnoj i političkoj
        sceni u Hrvatskoj, Srbiji i Austriji. Trebalo je da Nadežda Petrović
        izloži pet slika, međutim posle dve odbijene slike od strane domaćeg
        žirija izložiće samo tri: Beogradska ulica u snegu, Tiljerije na Seni i
        Bogorodičina crkva u Parizu. Kritika je i ovaj put ne primećuje, izuzev
        Dimitrija Mitrinovića koji o njoj piše kao o impresionisti. Umire joj
        otac Mita Petrović i blizak prijatelj Ivan Grohar. Izlaže na Jesenjem
        salonu gde dobija pohvalne kritike. Izlaže i na Salonu internacionalne
        unije.
      </Paragraph>

      <Bold>RAT</Bold>

      <Year>1912.</Year>
      <Paragraph>
        Vraća se u Srbiju. Predaje crtanje na Višoj ženskoj školi. Učestvuje u
        pripremi IV jugoslovenske umetničke izložbe u Beogradu. Na izložbi,
        Nadeždina Jugoslovenska umetnička kolonija nastupa sa jugoslovenskim
        udruženjem "Medulić". Nadežda učestvuje sa devet slika iz pariskog
        perioda. Po prvi put dobija dobre kritike. Naročito se izdvaja kritika
        Moše Pijade i Dimitrija Mitrinovića. I sama piše značajnu kritiku
        izložbe gde iznosi svoje stavove o savremenom slikarstvu, toku umetnosti
        kod nas i u svetu kao i principima i načelima umetnosti. Otvara "letnji
        kurs za slikanje". To je godina početka Prvog balkanskog rata u koji se
        Nadežda dobrovoljno prijavljuje da bude bolničarka na frontu. Umire
        Mileva Zorić, majka Nadežde Petrović.
      </Paragraph>

      <Year>1913.</Year>
      <Paragraph>
        Slika Vezirov most. U Prizrenu nastaje njena najpoznatija fotografija sa
        fronta u bolničkoj uniformi. Za vreme Drugog balkanskog rata ponovo je
        na frontu. Tad nastaje slika Gračanica. Oporavlja se posle preležanog
        trbušnog tifusa. Nadežda dobija Orden za hrabrost i Crveni krst. Odlazi
        na kraće putovanje sa sestrom Anđom u Veneciju radi oporavka ali brzo se
        vraća zbog iscrpljenosti. Po povratku za Beograd radi ilustracije za
        narodne epske pesme. Postaje prva sekretarka Odbora za organizaciju
        umetničkih poslova Srbije i jugoslovenstva.
      </Paragraph>
      <Year>1914.</Year>
      <Paragraph>
        Umire Nadeždina sestra Anđa. Sa najmlađim bratom Rastkom, Nadežda odlazi
        u Veneciju. Posle ubistva Franca Fedinanda u Sarajevu, Austro-Ugarska
        objavljuje rat Srbiji. Nadežda prekida odmor u Veneciji i vraća se u
        Beograd. Tad nastaje slika Fasada crkve sv. Marka u Veneciji kao
        poslednja uspomena na Veneciju. Po povratku u Beograd kao dobrovoljna
        bolničarka raspoređena je u poljsku bolnicu Dunavske divizije. Nalazi se
        na ratištu kod Mačkovog kamena odakle u pismu rodbini podrobno opisuje
        čitav događaj bitke.
      </Paragraph>
      <Year>1915.</Year>
      <Paragraph>
        Odlazi u Skoplje. Posle smrti sestre Drage ponovo odlazi na front u Prvu
        rezervnu bolnicu u Valjevu gde počinje velika epidemija pegavog tifusa.
        Nastaju slike Ruševine i Valjevska bolnica. U prolazu sa ratišta obilazi
        je Branko Popović, što će ujedno biti njihov poslednji susret. Nadežda
        Petrović umire u Valjevu 3. aprila od tifusa.
      </Paragraph>
      <Bold>
        Izvori: Katarina Ambrozić, Nadežda Petrović, CKZ, Jugoslavijapublik,
        Beograd 1978 Lidija Merenik, Nadežda Petrović, Topy, Vojnoizdavački
        zavod, Beograd 2006 Nadežda Petrović, Nadežda Petrović 1873-1915, MSU,
        Beograd 1973
      </Bold>
      <div style={{ height: "50px" }} />
    </Container>
  );
};

export default NadezdaPetrovic;
